import React from 'react';
import RequestYourKnaekID from "../../components/AppSections/HomepageSections/RequestYourKnaekID";
import FooterSection from "../../components/FooterSection/Footer";
import PrivacyContent from "../../components/AppSections/Privacysection/PrivacyContent";

export default function TermsAndConditions() {
    return (
        <div className="homepage-4 pt-5 mt-5">
            <div className="main">
                <PrivacyContent />
                <RequestYourKnaekID />
                <FooterSection/>
            </div>
        </div>
    );
}
